module.exports = __webpack_public_path__ + "static/img/名人校友.d314dbbb.png";